import axiosInstanceAuth from "./axiosInstanceAuth";
import { mergeRentalProfile } from "../Constants/rentalProfile";

const unwrapProfile = (res) => {
  const payload = res?.data?.data ?? res?.data?.profile ?? res?.data;
  if (payload && typeof payload === "object" && !Array.isArray(payload)) {
    return mergeRentalProfile(payload);
  }
  return mergeRentalProfile(null);
};

export const fetchRenterProfile = async () => {
  const res = await axiosInstanceAuth.get("/renterProfile");
  return unwrapProfile(res);
};

export const updateRenterProfileSection = async (section, data) => {
  const res = await axiosInstanceAuth.patch("/renterProfile", { section, data });
  return unwrapProfile(res);
};
